import { render, staticRenderFns } from "./invoicesIncomePage.vue?vue&type=template&id=e350bcbe&"
import script from "./invoicesIncomePage.vue?vue&type=script&lang=ts&"
export * from "./invoicesIncomePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports